function convertToPoints(_ref) {
  var xMin = _ref.xMin,
      xMax = _ref.xMax,
      yMin = _ref.yMin,
      yMax = _ref.yMax;
  return [{
    x: xMin,
    y: yMin
  }, {
    x: xMax,
    y: yMin
  }, {
    x: xMax,
    y: yMax
  }, {
    x: xMin,
    y: yMax
  } // bl
  ];
}

export { convertToPoints };